import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const PHONE = "706-506-3860";
export const PHONE_TEL = "+17065063860";
export const PHONE_HELP = "1-659-256-3484";
export const PHONE_HELP_TEL = "+16592563484";
export const BRAND = "Clear Path Home Relief Services";
